import { Spinner } from '../Spinner/Spinner';

export const LoadingScreen = () => {
	return (
		<div className="absolute flex items-center justify-center inset-0 bg-white/80 z-50">
			<Spinner size="large" />
		</div>
	);
};
